export default "__VITE_ASSET__Cm$bgWV8__"